(function ($) {
    $(document).ready(function(){
        // Initially hide all accordion content
        $('.collapse').hide();
        $('.btn-link').attr('aria-expanded', 'false'); // Set all to not expanded

        // Trigger action when the accordion header is clicked
        $('.btn-link').click(function(e){
            // Prevent the default action
            e.preventDefault();

            // Get the ID of the target element to toggle
            var targetID = $(this).data('target');

            // Toggle visibility with a slide animation
            $(targetID).slideToggle();

            // Adjust the aria-expanded attribute based on visibility
            var ariaExpanded = $(this).attr('aria-expanded') === 'true' ? 'false' : 'true';
            $(this).attr('aria-expanded', ariaExpanded);

            // Toggle the rotate class on the accordion arrow for the clicked section
            $(this).find('.accordion_arrow').toggleClass('rotate');
        });
    });
})(jQuery);
